'use strict';

var _require = require('./stereotype_client'),
    StereotypeClient = _require.StereotypeClient,
    supportedEnvironments = _require.supportedEnvironments;

module.exports = StereotypeClient;
module.exports.supportedEnvironments = supportedEnvironments;